import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';
export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'aarsag';
            break;
        case 'aarsag':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'skete-skaden-under-reparation';
            break;

        case 'skete-skaden-under-reparation':
            if (getValueOrDefault(formConfig, formValues, 'isDamageCausedUnderRepair').value === 'y') {
                nextPage = 'genstandsregistrering';
            } else {
                nextPage = 'skyldes-skaden-en-fejl';
            }
            break;

        case 'skyldes-skaden-en-fejl':
            nextPage = 'genstandsregistrering';
            break;

        case 'genstandsregistrering':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'i-hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }

            break;

        case 'i-hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
